import {
  faCircle,
  faUpRightFromSquare,
} from "@fortawesome/pro-solid-svg-icons";
import { twJoin } from "tailwind-merge";

import { ExternalLink } from "src/base-components/ExternalLink";
import { Pill } from "src/base-components/Pill";
import { Agent } from "src/clients/agent-management";
import { Icon } from "src/design-system/Icon";
import { Tooltip } from "src/design-system/Tooltip";
import { useAuthoringContext } from "src/router/routerContextHooks";
import { getBaseUrl, getUrlToAgentVersionsPage } from "src/router/urls";

type AgentCardProps = {
  agent: Agent;
  onClick: () => void;
};

export const AgentCard: React.FC<AgentCardProps> = ({ agent, onClick }) => {
  const { orgId, workspace } = useAuthoringContext();
  const publishedCount = agent.published_versions_count ?? 0;
  const draftCount = agent.draft_versions_count ?? 0;

  const agentUrl = `${getBaseUrl()}${getUrlToAgentVersionsPage(orgId, workspace.id, agent.id)}`;

  return (
    <li
      className={twJoin(
        "group cursor-pointer rounded-lg border border-gray-200 p-4",
      )}
      data-loc={`agent-card-${agent.id}`}
      onClick={onClick}
    >
      <div className="mb-2 flex items-center justify-between">
        <h4 className="font-inter-semibold-13px text-gray-800">{agent.name}</h4>
        <Tooltip placement="bottom-end" title="Open in new tab" asChild>
          <div>
            <ExternalLink
              className="text-gray-500"
              href={agentUrl}
              onClick={(e) => e.stopPropagation()}
            >
              <Icon icon={faUpRightFromSquare} size="xs" />
            </ExternalLink>
          </div>
        </Tooltip>
      </div>
      <p className="mb-4 line-clamp-3 whitespace-pre-line font-inter-normal-12px text-gray-500">
        {agent.description || "No description"}
      </p>
      <div className="flex flex-wrap gap-1">
        {publishedCount > 0 && (
          <Pill variant="green">
            <Pill.Icon icon={faCircle} size="sm" />
            <Pill.Text>{publishedCount} Published</Pill.Text>
          </Pill>
        )}
        {draftCount > 0 && (
          <Pill variant="yellow">
            <Pill.Text>{draftCount} Draft</Pill.Text>
          </Pill>
        )}
      </div>
    </li>
  );
};
